import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
function InputControl(_ref) {
  let {
    onChange,
    onBlur,
    ...props
  } = _ref;
  const onChangeInput = useCallback(value => {
    onChange && onChange(props.name, value);
  }, [onChange, props.name]);
  const onBlurInput = useCallback(value => {
    onBlur && onBlur(props.name, value);
  }, [onBlur, props.name]);
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    isFullWidth: true,
    onChange: onChangeInput,
    onBlur: onBlurInput
  }));
}
process.env.NODE_ENV !== "production" ? InputControl.propTypes = {
  onChange: PropTypes.func
} : void 0;
export default /*#__PURE__*/React.memo(InputControl);